module.exports = __webpack_public_path__ + "static/Veneers 1 intraoral after-6b16143af1aaddb60caaf2f82de29ec9.jpg";